export default "__VITE_ASSET__4b839530__"